import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { ModalContext, ModalKey } from 'components/Modals/ModalContext'
import { ArrowPathIcon, ArrowUturnLeftIcon } from '@heroicons/react/24/solid'
import { equipmentMedia } from 'functions/equipmentUtils'

export default function WorkoutPreview({
    workoutType,
    workoutTemplate,
    allowExerciseSwap = true,
    SwapWorkoutPreviewExercise = () => { },
    UndoWorkoutPreviewExerciseSwap = () => { }
}) {

    const exercises = useSelector((state) => state.whichWeightCache.exercises)
    const { ShowModal, HideModal } = useContext(ModalContext)

    const ShowExerciseInstructionsModal = (exerciseId) => {
        const modalData = {
            key: ModalKey.ExerciseInstructions,
            fullscreen: true,
            exerciseId: exerciseId,
        }

        ShowModal(modalData)
    }

    const ShowExerciseSwapModal = (phaseIndex, exerciseIndex, exercise) => {
        const modalData = {
            key: ModalKey.ExerciseSwap,
            fullscreen: true,
            phaseKey: workoutTemplate.phases[phaseIndex].phaseKey,
            currentExercise: exercise,
            selectAction: async (swapType, swapExercise) => {
                SwapWorkoutPreviewExercise(
                    phaseIndex,
                    exerciseIndex,
                    swapType,
                    swapExercise
                )

                HideModal()
            }

        }

        ShowModal(modalData)
    }

    return (
        <div className='space-y-8'>
            {workoutTemplate.phases.map((phase, phaseIndex) => (
                <div
                    key={phaseIndex}
                    className='space-y-4'
                >
                    {phase.type === 'circuit' &&
                        <div className='flex pr-2'>
                            <p className='text-sm text-gray-500 flex-grow'>{phase.name}</p>
                            <p className="text-sm text-gray-500">{phase.circuitRounds} round{phase.circuitRounds > 1 ? 's' : ''}</p>
                        </div>
                    }

                    {phase.exercises.map((exercise, exerciseIndex) => (
                        <div
                            key={exerciseIndex}
                            className="flex items-center gap-x-4 p-2 bg-white rounded-2xl shadow-md"
                        >
                            {exercises.length > 0 && (
                                <img
                                    src={exercises.find((item) => item.id === exercise.id)?.imageUrl}
                                    alt="Exercise Thumbnail"
                                    className="w-16 h-16 object-cover rounded-lg cursor-pointer"
                                    onClick={() => ShowExerciseInstructionsModal(exercise.id)}
                                    onError={(e) => {
                                        e.target.style.display = 'none'
                                    }}
                                />
                            )}

                            <div
                                className='space-y-1 overflow-hidden cursor-pointer'
                                onClick={() => ShowExerciseInstructionsModal(exercise.id)}
                            >
                                <div className="text-base">{exercise.name}</div>

                                {exercise.equipment && exercise.equipment.length > 0 &&
                                    <div className='flex gap-x-1'>
                                        {exercise.equipment.split(',').map((equipment, index) => (
                                            <img
                                                key={index}
                                                src={equipmentMedia[equipment]?.imageURL}
                                                alt="Equipment Icon"
                                                className="h-6"
                                            />
                                        ))}
                                    </div>
                                }
                            </div>

                            <div className='flex-1' />

                            {allowExerciseSwap && workoutType === 'program' &&
                                <div>
                                    {exercise.originalExerciseStorage === null && (
                                        <div
                                            className='h-14 w-14 flex flex-col items-center justify-center rounded-xl font-normal pr-2 cursor-pointer'
                                            onClick={() => ShowExerciseSwapModal(phaseIndex, exerciseIndex, exercise)}
                                        >
                                            <ArrowPathIcon className="h-8 w-8 text-gray-600 mt-1 mb-0.5" />
                                            <p className="text-sm text-gray-700">Swap</p>
                                        </div>
                                    )}

                                    {exercise.originalExerciseStorage !== null && (
                                        <div
                                            className='h-14 w-14 flex flex-col items-center justify-center rounded-xl font-normal'
                                            onClick={() => UndoWorkoutPreviewExerciseSwap(phaseIndex, exerciseIndex)}
                                        >
                                            <ArrowUturnLeftIcon className='text-gray-700 w-6 h-6 mt-1 mb-0.5' />
                                            <p className="text-xxs text-gray-700">Undo</p>
                                        </div>
                                    )}
                                </div>
                            }
                        </div>
                    ))}
                </div>
            ))}
        </div>
    )
}
